import { useMutation } from 'react-query';
import {
  createSchoolBoardAsync,
  deleteSchoolBoardAsync,
  getAllSchoolBoardsByLicenseAsync,
  getSchoolBoardByIdAsync,
  updateSchoolBoardAsync,
} from '../../index';
import { IPaginationParams } from '../../../types';
import { ISchoolBoardFilterParams } from '../../types';

export const useCreateSchoolBoardAsync = () => useMutation(createSchoolBoardAsync);

export const useGetSchoolBoardByIdAsync = () => useMutation(getSchoolBoardByIdAsync);
export const useGetAllSchoolBoardsByLicenseAsync = () =>
  useMutation(
    ({
      pagination,
      filter,
    }: {
      pagination: IPaginationParams;
      filter: ISchoolBoardFilterParams;
    }) => getAllSchoolBoardsByLicenseAsync(pagination, filter)
  );

export const useUpdateSchoolBoardAsync = () => useMutation(updateSchoolBoardAsync);

export const useDeleteSchoolBoardAsync = () => useMutation(deleteSchoolBoardAsync);